/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Dayjs } from "dayjs";

import { ActivityToType } from "../api/types/types";
import { CreateOrEditFormValues } from "../components/CreateOrUpdateActivityModal/CreateOrUpdateActivityModal";

const getDateTime = (date: Dayjs | undefined, time: Dayjs | undefined): string => {
  if (!date) {
    return "";
  }
  if (!time) {
    return date.toISOString();
  }
  return date.hour(time.hour()).minute(time.minute()).toISOString();
};

export const mapBaseActivityInputsToPayload = (
  currentFarmerAccountNumber: string,
  values: CreateOrEditFormValues
) => ({
  accountNumber: currentFarmerAccountNumber,
  activityType: Number(values.activityType),
  subject: values.subject,
  description: values.description,
  scheduleDate: getDateTime(values.scheduleDate, values.startTime),
  dueDate: getDateTime(values.scheduleDate, values.startTime),
  status: values.activityStatus,
  to: values.contactId,
  toType: ActivityToType.Contact,
  contactId: values.contactId,
  duration: values.duration,
});
